import { Modal, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getActiveEnterpriseUserList } from '../../api/constlink';
import { User } from '../../modules/auth';

const StyledDiv = styled.div``;

const columns = [
  {
    title: '회사명',
    dataIndex: ['myEnterprise', 'name'],
    width: '30%',
  },
  {
    title: '이름',
    dataIndex: 'name',
    width: '20%',
  },
  {
    title: '이메일',
    dataIndex: 'email',
    width: '10%',
  },
];

interface AddPartnersModalProps {
  visible: boolean;
  enterpriseId: string;
  projectId: string;
  existingCollaborators: any[];
  onCreate: (userIdList: number[]) => void;
  onCancel: () => void;
}

function AddPartnersModal({
  visible,
  enterpriseId,
  projectId,
  existingCollaborators,
  onCreate,
  onCancel,
}: AddPartnersModalProps) {
  const [users, setUsers] = useState<User[]>([]);
  const [collaborators, setCollaborators] = useState<any[]>([]);
  const [selectedRowKeysLocal, setSelectedRowKeysLocal] = useState<React.Key[]>(
    [],
  );

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setUsers([...selectedRows]);
      setSelectedRowKeysLocal(selectedRowKeys);
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.disabled,
    }),
    selectedRowKeys: selectedRowKeysLocal,
  };

  useEffect(() => {
    const _getCollaboratorList = async () => {
      const data: any[] = await getActiveEnterpriseUserList(enterpriseId);
      for (const collaborator of data) {
        let disabled = false;
        for (const existingCollaborator of existingCollaborators) {
          if (existingCollaborator.id === collaborator.id) disabled = true;
        }
        collaborator.disabled = disabled;
      }
      setCollaborators(data);
    };

    if (visible) {
      setSelectedRowKeysLocal([]);
      setUsers([]);
      _getCollaboratorList();
    }
  }, [visible, enterpriseId, projectId, existingCollaborators]);

  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="공사참여자 추가"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          const _userIdList: number[] = [];
          for (const user of users) {
            _userIdList.push(user.id);
          }
          onCreate(_userIdList);
        }}
      >
        <Table
          rowKey="id"
          columns={columns}
          rowSelection={{ ...rowSelection, checkStrictly: false }}
          dataSource={collaborators}
        />
      </Modal>
    </StyledDiv>
  );
}

export default AddPartnersModal;
